<template>
  <!-- drawer people add -->
  <el-drawer
    :title="editorText + '人员'"
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog"
    direction="rtl"
    :show-close="false"
    @open="handleOpen"
  >
    <el-form label-width="120px" :rules="!editing ? rules : editRules" ref="form" :model="form">
      <el-row>
        <el-col :span="24">
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model.trim="form.name"
              :maxlength="20"
              placeholder="请输入姓名"
              :disabled="existedUser"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="证件类型" prop="idType">
            <el-select placeholder="请选择" v-model="form.idType" clearable :disabled="existedUser" @change="certificateValidate">
              <el-option
                v-for="item in idTypes"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="证件号码" prop="idCard">
            <el-input
              v-model.trim="form.idCard"
              :maxlength="20"
              placeholder="请输入证件号码"
              @blur="certificateValidate"
              :disabled="editing"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model.trim="form.phone"
              :maxlength="20"
              placeholder="请输入手机号"
              :disabled="existedUser"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="所属处室" prop="office">
            <el-select placeholder="请选择" v-model="form.office" clearable>
              <el-option
                v-for="item in offices"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="drawer-footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button size="small" type="primary" :disabled="submitting" @click="submitForm('form')">确 定</el-button>
    </div>
  </el-drawer>
</template>

<script>
// import _ from 'lodash'
import __ from '@/util/common-utils'
export default {
  props: ['identify', 'visible'],
  data () {
    var validateId = (rule, value, callback) => {
      if (/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value) === false) {
        callback(new Error('证件号码格式不正确'))
      } else {
        callback()
      }
    }
    var validatePhone = (rule, value, callback) => {
      if (/^(?:\+?86)?1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[235-8]\d{2}|4(?:0\d|1[0-2]|9\d))|9[0-35-9]\d{2}|66\d{2})\d{6}$/.test(value) === false) {
        callback(new Error('手机号格式不正确'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        name: [
          { required: true, message: '姓名不得为空', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        idType: [
          { required: true, message: '请选择证件类型', trigger: ['blur', 'change'] }
        ],
        idCard: [
          { required: true, message: '证件号码不得为空', trigger: 'blur' },
          { validator: validateId, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '手机号不得为空', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        office: [
          { required: false, message: '请选择处室', trigger: ['blur', 'change'] }
        ]
      },
      editRules: {
        name: [
          { required: true, message: '姓名不得为空', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        idType: [
          { required: true, message: '请选择证件类型', trigger: ['blur', 'change'] }
        ],
        idCard: [
          { required: true, message: '证件号码不得为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '手机号不得为空', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        office: [
          { required: false, message: '请选择处室', trigger: ['blur', 'change'] }
        ]
      },
      submitting: false,
      form: { id: null, name: '', idType: '', idCard: '', phone: '', office: '' },
      idTypes: [
        {
          name: '居民身份证',
          value: 1
        }
      ],
      offices: [],
      isLastSuccessful: false,
      existedUser: false
    }
  },
  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    },
    editing () { return this.identify && this.identify.id > 0 },
    editorText () { return this.identify && this.identify.id ? '编辑' : '添加' }
  },
  mounted () {

  },
  methods: {
    handleOpen () {
      this.submitting = false
      this.existedUser = false
      // 获取所属处室
      this.$xhrGet(`/acc/departments`).then(rs => {
        this.offices = rs.data
      })
      if (!this.editing) {
        setTimeout(() => {
          this.form = {}
          this.form = { id: null, name: '', idType: '', idCard: '', phone: '', office: '' }
          this.$refs.form.resetFields()
        }, 50)
      } else {
        this.form.name = this.identify.name
        this.form.idType = this.identify.certificate
        this.form.idCard = this.identify.certificateNo
        this.form.phone = this.identify.phone
        this.form.office = this.identify.department && this.identify.department.value
        this.$refs.form && this.$refs.form.clearValidate()
      }
    },

    closeDialog () {
      if (this.isLastSuccessful) {
        this.$emit('edit-result', true)
      }
      this.$emit('update:visible', false)
    },

    certificateValidate () {
      let reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (this.form.idType && this.form.idCard && reg.test(this.form.idCard)) {
        let param = {
          certificate: this.form.idType,
          certificateNo: this.form.idCard.toUpperCase()
        }
        this.$xhrGet(`/acc/ordinary-users/certificate/check`, param).then(rs => {
          if (rs.code === 'SUCCESS' && !rs.data) {
            this.existedUser = false
          } else if (rs.code === 'SUCCESS' && rs.data) {
            this.form.name = rs.data.name
            this.form.phone = rs.data.value
            this.existedUser = true
          } else if (rs.code === 'certificate_exists') {
            this.existedUser = false
            this.$message.error('证件号码已存在')
          }
        })
      }
    },

    xhrUpdate () {
      let realFormData = {
        name: this.form.name === this.identify.name ? null : this.form.name,
        phone: this.form.phone === this.identify.phone ? null : this.form.phone,
        certificate: this.form.idType === this.identify.certificate ? null : this.form.idType,
        certificateNo: this.form.idCard === this.identify.certificateNo ? null : this.form.idCard.toUpperCase(),
        institutionDepartmentId: this.form.office === (this.identify.department && this.identify.department.value) ? null : this.form.office
      }
      if (__.isObjectPropertiesAllNull(realFormData)) {
        this.submitting = false
        this.$message.error('请修改信息后提交')
        return
      }
      this.$xhrPut(`/acc/ordinary-users/${this.identify.id}`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
          if (rs.code === 'certificate_exists') {
            this.$message.error('证件号码已存在')
          } else if (rs.code === 'phone_exists') {
            this.$message.error('手机号已存在')
          }
        }
      })
    },

    xhrAdd () {
      let realFormData = {
        name: this.form.name,
        phone: this.form.phone,
        certificate: this.form.idType,
        certificateNo: this.form.idCard.toUpperCase(),
        institutionDepartmentId: this.form.office
      }
      this.$xhrPost(`/acc/ordinary-users`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
          if (rs.code === 'certificate_exists') {
            this.$message.error('证件号码已存在')
          } else if (rs.code === 'phone_exists') {
            this.$message.error('手机号已存在')
          }
        }
      })
    },

    submitForm (formName) {
      this.submitting = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editing ? this.xhrUpdate() : this.xhrAdd()
        } else {
          this.$message.error('请检查输入')
          this.submitting = false
          return false
        }
      })
    },

    change () {
      this.$refs.cascader.toggleDropDownVisible()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/district-admin/people/PeopleEditor.vue